// extracted by mini-css-extract-plugin
export var bgLayout = "LiveCode-module--bgLayout--egpv4";
export var center = "LiveCode-module--center--RToqi";
export var editor = "LiveCode-module--editor--Fk4ey";
export var error = "LiveCode-module--error--FVAFA";
export var padded = "LiveCode-module--padded--b+6sr";
export var preview = "LiveCode-module--preview--0VX9s";
export var root = "LiveCode-module--root--4cHDo";